import Collapse, { CollapseProps, Panel, PanelProps } from './Collapse'

export default Collapse
export { Panel }
export type { CollapseProps, PanelProps }
